const leaveConversation = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        leavingConversation: true,
      };
    case 'success':
    case 'error':
      return {
        ...state,
        leavingConversation: false,
      };
    default:
      return state;
  }
};

export default leaveConversation;
